import CreditCard from 'feature/mochi-pay-flow/credit-card/credit-card';
import { CreditCardProvider } from './use-credit-card';

const CreditCardContainer = () => {
  return (
    <CreditCardProvider>
      <CreditCard />
    </CreditCardProvider>
  );
};

export default CreditCardContainer;
